import React, { useEffect, useRef, useState } from "react";

// Keep a real image visible until playback starts, including iOS Low Power Mode.
export default function LandingHeroVideo({ src, poster }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [failed, setFailed] = useState(false);
  const [manual, setManual] = useState(false);
  const [reduceMotion] = useState(() =>
    Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches));

  const play = () => {
    const video = ref.current;
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.play()?.catch(() => setManual(true));
  };

  useEffect(() => {
    if (reduceMotion) { setManual(true); return; }
    play();
    const timer = setTimeout(() => setManual(true), 8000);
    return () => clearTimeout(timer);
  }, [reduceMotion]);

  const fill = { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" };
  return <>
    <img src={poster} alt="" aria-hidden="true" fetchPriority="high" style={fill} />
    <video ref={ref} src={src} poster={poster} autoPlay={!reduceMotion}
      muted loop playsInline preload={reduceMotion ? "none" : "metadata"}
      aria-hidden="true" style={{ ...fill, opacity: playing ? 1 : 0 }}
      onPlaying={() => { setPlaying(true); setManual(false); }}
      onPause={() => { setPlaying(false); setManual(true); }}
      onError={() => { setFailed(true); setPlaying(false); }} />
    {manual && !playing && !failed && <button type="button" onClick={play}
      style={{ position: "absolute", bottom: 24, right: 24, zIndex: 20,
        color: "white", background: "#0f172a", border: "1px solid white",
        padding: "10px 16px", borderRadius: 8 }}>
      Play background video
    </button>}
  </>;
}
